import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { LoadingphaseService } from './nav/service/loadingphase.service';

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss']
})
export class AppComponent {

   private _icons = [
      { type: 'file', file: 'fraportLogo' },
      // { type: 'file-icon-set', file: 'sprite-set' },
      { type: 'mat-icon', file: 'add_box' },
      { type: 'mat-icon', file: 'default' },
      { type: 'mat-icon', file: 'brightness_1' },
      { type: 'mat-icon', file: 'close' },
      { type: 'mat-icon', file: 'filter_center_focus' },
      { type: 'mat-icon', file: 'folder_shared' },
      { type: 'mat-icon', file: 'group_work' },
      { type: 'mat-icon', file: 'hdr_weak' },
      { type: 'mat-icon', file: 'indeterminate_check_box' },
      { type: 'mat-icon', file: 'keyboard_arrow_right' },
      { type: 'mat-icon', file: 'keyboard_arrow_left' },
      { type: 'mat-icon', file: 'keyboard_arrow_down' },
      { type: 'mat-icon', file: 'list' },
      { type: 'mat-icon', file: 'person_outline' },
      { type: 'mat-icon', file: 'more_horiz' },
      { type: 'mat-icon', file: 'more_vert' },
      { type: 'mat-icon', file: 'reorder' },
      { type: 'mat-icon', file: 'search' },
      { type: 'mat-icon', file: 'settings' },
      { type: 'mat-icon', file: 'storage' },
      { type: 'mat-icon', file: 'open_in_new' },
      { type: 'mat-icon', file: 'delete' },
      // { type: 'mat-icon-set',  file: 'notification' }
   ];

   constructor(
      private iconRegistry: MatIconRegistry,
      private sanitizer: DomSanitizer,
      private loadingphaseService: LoadingphaseService,
   ) {
      this.registerIcons();
      this.loadingphaseService.subscribeToContentBlockEmitter((loadingphase) => this.blockInteraction = loadingphase);
   }

   private blockInteraction = false;

   private registerIcons(): void {
      this._icons.forEach(elem => {
         let pathname = '';
         switch (elem.type) {
            case 'file':
               pathname = `assets/icons/${elem.file}.svg`;
               this.iconRegistry.addSvgIconInNamespace(
                  elem.type,
                  elem.file,
                  this.sanitizer.bypassSecurityTrustResourceUrl(pathname));
               break;
            case 'file-icon-set':
               pathname = `assets/icons/${elem.file}.svg`;
               this.iconRegistry.addSvgIconSetInNamespace(
                  elem.file,
                  this.sanitizer.bypassSecurityTrustResourceUrl(pathname));
               break;
            case 'mat-icon':
               pathname = `assets/icons/ic_${elem.file}_24px.svg`;
               this.iconRegistry.addSvgIconInNamespace(
                  elem.type,
                  elem.file,
                  this.sanitizer.bypassSecurityTrustResourceUrl(pathname));
               break;
            case 'mat-icon-set':
               pathname = `assets/icons/svg-sprite-${elem.file}.svg`;
               this.iconRegistry.addSvgIconSetInNamespace(
                  elem.file,
                  this.sanitizer.bypassSecurityTrustResourceUrl(pathname));
               break;
            default:
               console.warn('Unknown Icon definition!');
         }
      });
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/app.component.ts